import styled from 'styled-components';

interface ButtonProps {
    variant?: string;
    md?: boolean;
    disabled?: boolean;
}

export const Button = styled.button.withConfig({
    shouldForwardProp: (prop) => !['variant', 'md'].includes(prop),
})<ButtonProps>`
    background: ${props =>
        props.disabled
            ? props.variant === 'secondary' || props.variant === 'outline'
                ? 'transparent'
                : 'rgba(var(--brand-rgb), 0.55)'
            : props.variant === 'secondary' || props.variant === 'outline'
            ? 'transparent'
            : 'var(--brand)'};
    color: ${props =>
        props.variant === 'secondary' || props.variant === 'outline'
            ? 'var(--ink)'
            : 'var(--ink-inverse)'};
    border: ${props =>
        props.variant === 'secondary' || props.variant === 'outline'
            ? '1px solid var(--ink)'
            : '0 none'};
    font-family: var(--font-heading);
    font-weight: 600;
    font-size: ${props => (props.md ? '14px' : '16px')};
    padding: ${props => (props.md ? '8px 24px' : '12px 35px')};
    border-radius: var(--radius-pill);
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
    transition: background-color var(--duration-ui) var(--ease-out),
        border-color var(--duration-ui) var(--ease-out),
        color var(--duration-ui) var(--ease-out),
        box-shadow var(--duration-ui) var(--ease-out),
        opacity var(--duration-ui) var(--ease-out);
    box-shadow: ${props =>
        props.variant === 'secondary' || props.variant === 'outline'
            ? 'none'
            : '0 8px 15px rgba(var(--brand-rgb), 0.24)'};

    &:hover {
        background: ${props =>
            props.disabled
                ? undefined
                : props.variant === 'secondary' || props.variant === 'outline'
                ? 'var(--brand)'
                : 'var(--brand-hover)'};
        border-color: ${props =>
            props.variant === 'secondary' || props.variant === 'outline'
                ? 'var(--brand)'
                : undefined};
        color: var(--ink-inverse);
        opacity: 1;
    }
`;
